var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('CommonTreePannel',{attrs:{"leftData":_vm.leftData,"columns":_vm.selectPanelColumns,"rightData":_vm.value,"disabled":_vm.disabled},on:{"selectValues":_vm.handleValues}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }